// extracted by mini-css-extract-plugin
export default {"blog":"Blog_blog__XlEDP","row":"Blog_row__n4XLj","h3":"Blog_h3__zHITF","articles":"Blog_articles__TPwjk","moreArticles":"Blog_moreArticles__CdSq0"};